const t=t=>{var e=(()=>{switch(t){case"small":return 12;case"large":return 20;default:return 16}})();return{height:e,width:e}};export{t as getIconSizeStyle};
